/**
 * @fileoverview Agent definition for chapter-architect-remaining-v2.
 *
 * Generates the remaining chapters for a story based on existing content and the overall plot.
 *
 * @category narrative.chapters.planning
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'chapter-architect-remaining-v2',
  kind: 'primitive',
  name: 'Chapter Continuator',
  description: 'Generates the remaining chapters for a story based on existing content and the overall plot.',
  category: 'structure',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2024-06',
    lastUpdated: '2026-01',
    taxonomyPath: 'narrative.chapters.planning',
    usedBy: [
      'primitives/use-chapter-architect-remaining-v2.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'chapter-architect-v2',
      'chapter-planner-v2',
    ],
  },
};
